export default __webpack_public_path__ + "static/media/1216.38bb5682.jpg";